import type { RootState } from 'src/store';

export function customHeaders(originalHeaders: Headers, getState: () => RootState): Headers {
  const { accessToken } = getState().authToken;
  const headers = new Headers(originalHeaders);

  if (accessToken) {
    headers.set('Authorization', `Bearer ${accessToken}`);
  }

  headers.set('Content-Type', 'application/json');
  headers.set('Accept', '*/*');

  return headers;
}

export function legacyDexCustomHeaders(
  originalHeaders: Headers,
  getState: () => RootState,
): Headers {
  const { accessToken } = getState().authToken;
  const headers = new Headers(originalHeaders);

  if (accessToken) {
    headers.set('x-access-token', accessToken);
  }

  headers.set('Content-Type', 'application/json');

  return headers;
}
